<p-card class="mb-5 p-3">
  <ng-template #header
    ><div>
      <i class="fa-solid fa-screwdriver-wrench mr-3"></i>Maintenance status
    </div></ng-template
  >

  <p-fluid class="flex flex-wrap gap-4">
    <p-button
      class="w-full md:w-1/2 lg:w-1/3 xl:w-1/5 pl-4 pr-4"
      type="button"
      label="Start maintenance tunnel"
      pTooltip="This will give the box a kick, which will start the maintenance tunnel"
      icon="fa-solid fa-play"
      (click)="startMaintenanceTunnel()"
    />
    <p-button
      class="w-full md:w-1/2 lg:w-1/3 xl:w-1/5 pl-4 pr-4"
      type="button"
      label="Stop maintenance tunnel"
      pTooltip="This will shutdown the maintenance tunnel."
      icon="fa-solid fa-stop"
      (click)="stopMaintenanceTunnel()"
    />
    <p-button
      class="w-full md:w-1/2 lg:w-1/3 xl:w-1/5 pl-4 pr-4"
      type="button"
      label="Maintenance tunnel status"
      pTooltip="This will check if there's a connection made between the box and the server"
      icon="fa-solid fa-arrows-rotate"
      (click)="getMaintenanceTunnelStatus()"
    />

    <div class="w-full flex pl-4 pr-4">
      <div class="w-full md:w-1/2 lg:w-1/3 xl:w-1/5">
        @if (commandService.isLoadingMaintenance()) {
          <p>
            <p-message closable severity="info"
              ><i class="fa fa-spinner fa-spin mr-2"></i>
              {{ maintenanceInfoText }}</p-message
            >
          </p>
        }

        @if (commandService.errorMessageMaintenance()) {
          <p-message closable severity="error">
            {{ commandService.errorMessageMaintenance() }}</p-message
          >
        }

        @if (commandService.responseMaintenance()) {
          <p-message closable severity="success"
            >{{ maintenanceResponseText }}: {{ getMaintenanceStatusText() }}
          </p-message>
        }
      </div>
    </div>
  </p-fluid>
</p-card>

<p-card class="mb-5 p-3">
  <ng-template #header
    ><div>
      <i class="fa-solid fa-link mr-3"></i>External connection
    </div></ng-template
  >

  <p-fluid class="flex flex-wrap gap-4">
    <p-button
      [disabled]="commandService.isLoadingExternal()"
      class="w-full md:w-1/2 lg:w-1/3 xl:w-1/5 pl-4 pr-4"
      type="button"
      label="Start external tunnel"
      pTooltip="Starts the external communication - External parties can control the box after this"
      icon="fa-solid fa-play"
      (click)="startExtTunnel()"
    />
    <p-button
      [disabled]="commandService.isLoadingExternal()"
      class="w-full md:w-1/2 lg:w-1/3 xl:w-1/5 pl-4 pr-4"
      type="button"
      label="Stop external tunnel"
      pTooltip="Stops the external communication - External parties can't control this box anymore"
      icon="fa-solid fa-stop"
      (click)="stopExtTunnel()"
    />
    <p-button
      [disabled]="commandService.isLoadingExternal()"
      class="w-full md:w-1/2 lg:w-1/3 xl:w-1/5 pl-4 pr-4"
      type="button"
      label="Check tunnel enabled"
      pTooltip="Check if external communication is enabled in the box"
      icon="fa-solid fa-arrows-rotate"
      (click)="getExtTunnelStatus()"
    />
    <div class="w-full flex pl-4 pr-4">
      <div class="w-full md:w-1/2 lg:w-1/3 xl:w-1/5">
        @if (commandService.isLoadingExternal()) {
          <p>
            <p-message closable severity="info"
              ><i class="fa fa-spinner fa-spin mr-2"></i>
              {{ externalInfoText }}</p-message
            >
          </p>
        }

        @if (commandService.errorMessageExternal()) {
          <p-message closable severity="error">
            {{ commandService.errorMessageExternal() }}</p-message
          >
        }

        @if (commandService.responseExternal()) {
          <p-message closable severity="success" class="texttest">
            {{ externalResponseText }}: {{ getExternalStatusText() }}
          </p-message>
        }
      </div>
    </div>
  </p-fluid>
</p-card>

<p-card class="mb-5 p-3">
  <ng-template #header
    ><div>
      <i class="fa-solid fa-ellipsis-vertical mr-3"></i>Other
    </div></ng-template
  >

  <p-fluid class="flex flex-wrap gap-4">
    <p-button
      class="w-full md:w-1/2 lg:w-1/3 xl:w-1/5 pl-4 pr-4"
      type="button"
      label="Reboot the box"
      pTooltip="Watch out! This will reboot the entire box. Be completely sure before hitting this button."
      icon="fa-solid fa-power-off"
      (click)="rebootBox()"
    />

    <p-button
      class="w-full md:w-1/2 lg:w-1/3 xl:w-1/5 pl-4 pr-4"
      type="button"
      [label]="(activated ? 'Deactivate' : 'Activate') + ' this box'"
      [pTooltip]="
        (activated
          ? 'Deactivating this box will also stop the external communication.'
          : 'Activating this box will also start the external communication.') +
        ' Be completely sure before hitting this button.'
      "
      [icon]="activated ? 'fa-solid fa-xmark' : 'fa-solid fa-check'"
      (click)="activated ? activationBox() : activationBoxConfirmation($event)"
    />
    <div class="w-full flex pl-4 pr-4">
      <div class="w-full md:w-1/2 lg:w-1/3 xl:w-1/5">
        @if (
          commandService.isLoadingReboot() ||
          commandService.isLoadingActivation()
        ) {
          <p>
            <p-message closable severity="info"
              ><i class="fa fa-spinner fa-spin mr-2"></i> Trying to send
              message...</p-message
            >
          </p>
        }

        @if (commandService.errorMessageReboot()) {
          <p-message closable severity="error">
            {{ commandService.errorMessageReboot() }}</p-message
          >
        }

        @if (commandService.errorMessageActivation()) {
          <p-message closable severity="error">
            {{ commandService.errorMessageActivation() }}</p-message
          >
        }

        @if (commandService.responseReboot()) {
          <p-message closable severity="success"
            >{{ getRebootBoxText() }}
          </p-message>
        }

        @if (commandService.responseActivation()) {
          <p-message closable severity="success"
            >{{ getActivationText() }}
          </p-message>
        }
      </div>
    </div>
  </p-fluid>
</p-card>

<div class="hidden md:block">
  <p-card class="mb-5 p-3">
    <ng-template #header
      ><div><i class="fa-solid fa-terminal mr-3"></i>Commands</div></ng-template
    >
    @if (canShowCommandsSection) {
      <app-terminal [controller]="controller()"></app-terminal>
    } @else {
      It's not yet possible to use the commands section. Update the
      device_client first!
    }
  </p-card>
</div>

<p-confirmdialog />
